import MinCharactersRule from './min-characters';
import MaxCharactersRule from './max-characters';
import MinMaxCharactersRule from './min-max-characters';
import IncludeNumberRule from './include-number';
import IncludeUppercaseRule from './include-uppercase';
import IncludeLowercaseRule from './include-lowercase';
import NoOuterWhitespaceRule from './no-outer-whitespace';

[
  MinCharactersRule,
  MaxCharactersRule,
  MinMaxCharactersRule,
  IncludeNumberRule,
  IncludeUppercaseRule,
  IncludeLowercaseRule,
  NoOuterWhitespaceRule
].forEach(r => {
  r.isRule = true;
});

export {
  MinCharactersRule,
  MaxCharactersRule,
  MinMaxCharactersRule,
  IncludeNumberRule,
  IncludeUppercaseRule,
  IncludeLowercaseRule,
  NoOuterWhitespaceRule
};



// WEBPACK FOOTER //
// ./node_modules/@ux/criteria/rules/index.js